import axios from 'axios/dist/axios';

const convertToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

async function prepararParaEnviarAtendimento(atendimento) {
  let base64 = null;
  let arquivo = null;

  if (atendimento.arquivo) {
    base64 = await convertToBase64(atendimento.arquivo);

    arquivo = {
      data: base64
        .replace('data:', '')
        .replace(/^.+,/, ''),
      filename: atendimento.arquivo.name,
      mimetype: atendimento.arquivo.type,
    }
  }

  let telefone = '';
  if (atendimento.telefone) {
    telefone = ` - Telefone: ${atendimento.telefone}`;
  }

  let celular = '';
  if (atendimento.celular) {
    celular = ` - Celular: ${atendimento.celular}`;
  }

  return {
    title: `Formulário - ${atendimento.nome}`,
    group_id: atendimento.area,
    customer_id: `guess:${atendimento.email}`,
    patrimonio: '',
    categoria: '',
    categoriaprojeto: '',
    categoriacursos: '',
    siglaprojeto: atendimento.codigoProjeto,
    motivo: atendimento.motivo,
    owner_id: atendimento.analista,
    article: {
      to: atendimento.email,
      cc: '',
      subject: `Interação via formulário ${atendimento.fundacao}`,
      body: `Nome: ${atendimento.nome}${telefone}${celular} - \n${atendimento.mensagem}`,
      type: 'email',
      internal: false,
      created_by: atendimento.email,
      attachments: arquivo ? [arquivo] : null,
    },
  };
}

export default {
  enviar: async (atendimento) => {
    atendimento = await prepararParaEnviarAtendimento(atendimento);

    return axios
      .post('https://contato.fau.org.br/tickets', atendimento)
      .then((res) => {
        return res.data;
      });
  },
  grupos: () => {
    return axios
      .get('https://contato.fau.org.br/tickets/groups')
      .then((res) => {
        return res.data;
      });
  },
  analistas: (idGrupo) => {
    return axios
      .get(`https://contato.fau.org.br/tickets/users/${idGrupo}`)
      .then((res) => {
        return res.data;
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/atendimento/servico.js